import { pushToDataLayer } from "./gtm";

const pushSocialData = (dataText, dataBlogTitle) => {
  pushToDataLayer({shareIcon: dataText, blogTitle: dataBlogTitle, event: "blogSocialShare" })
}

export default pushSocialData;